<template>
    <div class="sync-save-box">
        <v-dialog
            v-model="comfirmVisible"
            class="sync-save-confirm-dialog"
            :title="syncMode === 1 ? $t('选择同步方式为「完全使用企业微信的通讯录」？') : $t('选择同步方式为「从企业微信导入员工到企点」？')"
            kind="confirm"
            @confirm="addSyncConfigReq"
        >
            <div>{{ $t('请确认以下事项：') }}</div>
            <ul v-if="syncMode === 2">
                <li>{{ $t('可以从企业微信导入员工到企点，也可以在企点中创建员工') }}</li>
                <li>{{ $t('从企业微信导入的员工，员工信息不会自动同步到企点') }}</li>
                <li>{{ $t('从企业微信导入的员工，可以在企业微信上使用企点应用') }}</li>
            </ul>
            <ul v-else>
                <li>{{ $t('只能从企业微信创建员工，企点中无法创建员工') }}</li>
                <li>{{ $t('企业微信中的员工信息将自动同步到企点(每2小时同步一次)') }}</li>
                <li>{{ $t('所有员工都可以在企业微信上使用企点应用') }}</li>
            </ul>
            <span slot="confirm-text">{{ $t('开启') }}</span>
        </v-dialog>
    </div>
</template>

<script>
import Gateway from '@/utils/Gateway';

export default {
    data() {
        return {
            reqData: {},
            comfirmVisible: false,
            confirmPromiseResolve() {}
        };
    },

    computed: {
        syncMode() {
            return this.reqData && this.reqData.sync_mode;
        }
    },

    methods: {
        updateSyncRule(params) {
            this.reqData = params && params.reqData;

            return Gateway.post('/v1/wework/UpdateSyncRule', {
                ...this.reqData
            })
                .then(() => {
                    this.$message.success(this.$t('保存成功'));
                })
                .catch(message => {
                    this.$message.error(message || this.$t('保存失败'));
                });
        },

        addSyncConfig(params) {
            this.reqData = params && params.reqData;
            this.comfirmVisible = true;
            return new Promise(resolve => {
                this.confirmPromiseResolve = resolve;
            });
        },

        addSyncConfigReq() {
            Gateway.post(
                '/v1/wework/AddSyncConfig',
                {
                    ...this.reqData
                },
                {
                    originRes: true
                }
            )
                .then(res => {
                    const { code } = res || {};

                    if (code === 0) {
                        this.$message.success(this.$t('开启通讯录同步成功'), () => {
                            this.confirmPromiseResolve(res);
                        });
                    } else if (code === 100009) {
                        this.$alert({
                            title: this.$t('企点组织架构内没有员工和部门时，才能完全使用企业微信的通讯录')
                        });
                    }
                })
                .catch(message => {
                    this.$message.error(message || this.$t('开启通讯录同步失败'));
                });
        }
    }
};
</script>
<style lang="less" scoped>
@import './sync-save.less';
</style>
